import React from 'react'
// Components
import i18n from 'i18next'
import PropTypes from 'prop-types'
import {Close} from '../Icons/index.jsx'
import {forgotPassword} from '../Services/api.jsx'
import {apiErrorToMessage} from '../Services/helpers.jsx'
import {showSnackbar} from '../Services/domBridge.jsx'
import Spinner from './Spinner.jsx'
import Input from './Input.jsx'

export default class ForgotPasswordModal extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
    isSigninAndOrder: PropTypes.bool,
    onBackToSignginClick: PropTypes.func,
  }
  state = {
    usernameEmail: '',
    isFormSubmitted: false,
    isPending: false,
  }

  preventDismiss = (event) => {
    event.stopPropagation()
  }

  updateUsernameEmail = (value) => {
    this.setState({
      usernameEmail: value,
    })
  }

  onForgotPassword = async (event) => {
    if (event && event.preventDefault) event.preventDefault()

    const {usernameEmail} = this.state
    const {onDismiss} = this.props
    const isUsernameEmailValid = usernameEmail.length > 0

    this.setState({
      isFormSubmitted: true,
    })

    if (!isUsernameEmailValid) return

    this.setState({isPending: true})

    try {
      await forgotPassword(usernameEmail)

      this.setState({isPending: false}, () => {
        showSnackbar(
          i18n.t('Components.ForgotPasswordModal.onSuccess'),
          'success',
        )
        onDismiss()
      })
    } catch (error) {
      this.setState({isPending: false}, () => {
        showSnackbar(apiErrorToMessage(error), 'error')
      })
    }
  }

  render = () => {
    const {usernameEmail, isPending, isFormSubmitted} = this.state
    const {onDismiss, onBackToSignginClick} = this.props
    const isUsernameEmailValid = usernameEmail.length > 0

    return (
      <div className={'modal modal--small'} onClick={onDismiss}>
        <div className={'modal__body'} onClick={this.preventDismiss}>
          <form onSubmit={this.onForgotPassword}>
            <div className={'modal__content login'}>
              <Close
                className={'modal__header-close--always-visible'}
                onClick={onDismiss}
              />
              <h4>{i18n.t('Components.ForgotPasswordModal.title')}</h4>
              <p className={'login__subtitle'}>
                {i18n.t('Components.ForgotPasswordModal.subtitle')}
              </p>
              <Input
                label={i18n.t('Components.ForgotPasswordModal.emailLabel')}
                placeholder={i18n.t(
                  'Components.ForgotPasswordModal.emailPlaceholder',
                )}
                value={usernameEmail}
                autoComplete={'email username'}
                onChange={this.updateUsernameEmail}
                isValid={isUsernameEmailValid}
                showValidation={isFormSubmitted}
                isMandatory={true}
                invalidMessage={i18n.t(
                  'Components.ForgotPasswordModal.emailInvalidMessage',
                )}
                maxLength={180}
              />
            </div>
            <div className={'modal__footer modal__footer--hide-border'}>
              {isPending ? (
                <div className={'button button--compact'}>
                  <Spinner isWhite={true} />
                </div>
              ) : (
                <button className={'button--compact'} type={'submit'}>
                  {i18n.t('Components.ForgotPasswordModal.submitButton')}
                </button>
              )}
              <span className={'link'} onClick={onBackToSignginClick}>
                {i18n.t('Components.ForgotPasswordModal.signin')}
              </span>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
